import React from 'react';
import {OperatorSocialSettings, OperatorSocialSettingsData} from "types/Operator";
import {Form, Formik, FormikHelpers} from "formik";
import Field from "components/Form/Field";
import FormControls from "components/FormControls";
import {FacebookIcon, InstagramIcon, TikTokIcon, TwitterIcon} from "components/Icon/social";
import * as Yup from "yup";
import {ErrorNotification} from "../../../components/Form/ErrorNotification";

type Props = {
    settings?: OperatorSocialSettings | null
    onSubmit: (values: OperatorSocialSettingsData, helpers: FormikHelpers<OperatorSocialSettingsData>) => any
}

function SocialForm(props: Props) {
    const validationSchema = Yup.object().shape({
        twitter: Yup.string().max(255, 'Maximum of 255 characters').matches(/^https:\/\/(www.)?twitter.com\/.+/, 'Must start with https://twitter.com/ or https://www.twitter.com/.'),
        facebook: Yup.string().max(255, 'Maximum of 255 characters').matches(/^https:\/\/(www.)?facebook.com\/.+/, 'Must start with https://facebook.com/ or https://www.facebook.com/.'),
        instagram: Yup.string().max(255, 'Maximum of 255 characters').matches(/^https:\/\/(www.)?instagram.com\/.+/, 'Must start with https://instagram.com/ or https://www.instagram.com/.'),
        tiktok: Yup.string().max(255, 'Maximum of 255 characters').matches(/^https:\/\/(www.)?tiktok.com\/.+/, 'Must start with https://tiktok.com/ or https://www.tiktok.com/.'),
    })

    const initialValues: OperatorSocialSettingsData = {
        twitter: props.settings?.twitter || '',
        facebook: props.settings?.facebook || '',
        instagram: props.settings?.instagram || '',
        tiktok: props.settings?.tiktok || '',
    }

    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={props.onSubmit}>
            {formik => (
                <section aria-labelledby="payment-details-heading">
                    <Form onKeyDown={event => {if(event.ctrlKey && event.key === 'Enter') formik.handleSubmit()}}>
                        <ErrorNotification formik={formik} />

                        <div className="shadow sm:rounded-md">
                            <div className="bg-white py-6 px-4 sm:p-6 sm:rounded-md">
                                <div>
                                    <h2 id="payment-details-heading" className="text-lg leading-6 font-medium text-gray-900">
                                        Social Profiles
                                    </h2>
                                    <p className="mt-1 text-sm text-gray-500">
                                        Links to your social media profiles which are applied to the footer of email messages
                                    </p>
                                </div>

                                <div className="mt-6 grid grid-cols-6 gap-6">

                                    {/* Twitter */}
                                    <div className="col-span-6 sm:col-span-3">
                                        <Field
                                            type="url"
                                            icon={TwitterIcon}
                                            label="Twitter"
                                            hint="Optional. 255 chars max."
                                            name="twitter"
                                            id="twitter"
                                            maxLength={255}
                                            autoComplete="off"
                                        />
                                    </div>

                                    {/* Facebook */}
                                    <div className="col-span-6 sm:col-span-3">
                                        <Field
                                            type="url"
                                            icon={FacebookIcon}
                                            label="Facebook"
                                            hint="Optional. 255 chars max."
                                            name="facebook"
                                            id="facebook"
                                            maxLength={255}
                                            autoComplete="off"
                                        />
                                    </div>

                                    {/* Instagram */}
                                    <div className="col-span-6 sm:col-span-3">
                                        <Field
                                            type="url"
                                            icon={InstagramIcon}
                                            label="Instagram"
                                            hint="Optional. 255 chars max."
                                            name="instagram"
                                            id="instagram"
                                            maxLength={255}
                                            autoComplete="off"
                                        />
                                    </div>

                                    {/* TikTok */}
                                    <div className="col-span-6 sm:col-span-3">
                                        <Field
                                            type="url"
                                            icon={TikTokIcon}
                                            label="TikTok"
                                            hint="Optional. 255 chars max."
                                            name="tiktok"
                                            id="tiktok"
                                            maxLength={255}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                            </div>

                            <FormControls formik={formik} compact withoutCancel />
                        </div>
                    </Form>
                </section>
            )}
        </Formik>
    );
}

export default SocialForm;